import { createFileRoute } from "@tanstack/react-router";
import ExecutiveAssistantWatchingBossFallApart from "@/pages/articles/ExecutiveAssistantWatchingBossFallApart";
export const Route = createFileRoute("/watching-your-boss-fall-apart")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Watching Your Boss Fall Apart | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Watching your boss struggle with depression? Learn how to help and what treatment options like TMS exist in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Watching Your Boss Fall Apart | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Watching your boss struggle with depression? Learn how to help and what treatment options like TMS exist in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/watching-your-boss-fall-apart",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/watching-your-boss-fall-apart",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ExecutiveAssistantWatchingBossFallApart />;
}
